import _ from 'underscore';
import { IMetricInfo } from '../../metrics/models/IMetricInfo';
import { AccelerationTaskMapper } from '../mappers/AccelerationTaskMapper';
import { AlertListMapper } from '../mappers/AlertMapper';
import { ContentMapper } from '../mappers/ContentMapper';
import { DataAlertMapper } from '../mappers/DataAlertMapper';
import { DataConnectionMapper } from '../mappers/DataConnectionMapper';
import { DataRoleMapper } from '../mappers/DataRoleMapper';
import { DatasourceMapper } from '../mappers/DatasourceMapper';
import { ExtractTaskMapper } from '../mappers/ExtractTaskMapper';
import { FlowMapper } from '../mappers/FlowMapper';
import { FlowOutputStepMapper } from '../mappers/FlowOutputStepMapper';
import { FlowOutputStepRunMapper } from '../mappers/FlowOutputStepRunMapper';
import { MetricMapper } from '../mappers/MetricMapper';
import { ProjectMapper } from '../mappers/ProjectMapper';
import { PublishedConnectionMapper } from '../mappers/PublishedConnectionMapper';
import { RemoteRefreshAgentMapper } from '../mappers/RemoteRefreshAgentMapper';
import { RemoteRefreshScheduleMapper } from '../mappers/RemoteRefreshScheduleMapper';
import { RunFlowTaskMapper } from '../mappers/RunFlowTaskMapper';
import { ShareActivityMapper } from '../mappers/ShareActivityMapper';
import { SharedWithMeMapper } from '../mappers/SharedWithMeMapper';
import { SubscriptionMapper } from '../mappers/SubscriptionMapper';
import { UserMapper } from '../mappers/UserMapper';
import { UserWithImageMapper } from '../mappers/UserWithImageMapper';
import { ViewMapper } from '../mappers/ViewMapper';
import { WorkbookAccelerationMapper } from '../mappers/WorkbookAccelerationMapper';
import { WorkbookMapper } from '../mappers/WorkbookMapper';
import { ExplorableItemType } from '../models/ContentType';
import { FlowListItemInfo } from '../models/FlowInfo';
import { FlowOutputStepInfo } from '../models/FlowOutputStepInfo';
import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';
import { IAlertListInfo } from '../models/IAlertInfo';
import { IContentInfo } from '../models/IContentInfo';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IDataConnectionInfo } from '../models/IDataConnectionInfo';
import { IDataRoleInfo } from '../models/IDataRoleInfo';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { IGroupInfo } from '../models/IGroupInfo';
import { IProjectInfo } from '../models/IProjectInfo';
import { IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';
import { IRecentContentInfo } from '../models/IRecentContentInfo';
import { IRemoteRefreshAgentInfo } from '../models/IRemoteRefreshAgentInfo';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { ISharedVersionInfo } from '../models/ISharedVersionInfo';
import { ISharedWithMeContentInfo } from '../models/ISharedWithMeContentInfo';
import { ISiteUserInfo } from '../models/ISiteUserInfo';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { IViewInfo } from '../models/IViewInfo';
import { IViewRecommendationInfo } from '../models/IViewRecommendationInfo';
import { IWorkbookAccelerationInfo } from '../models/IWorkbookAccelerationInfo';
import { IWorkbookInfo } from '../models/IWorkbookInfo';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { CustomViewMapper } from '../ServerApi/CustomViews/CustomViewMapper';
import { IGetCustomizedViewsResult } from '../ServerApi/CustomViews/GetCustomizedViewsRequest';
import { ICustomViewInfo } from '../ServerApi/CustomViews/ICustomViewInfo';
import { IExploreContentResult } from '../ServerApi/requests/ExploreContentRequest';
import { IGetAccelerationTasksResult } from '../ServerApi/requests/GetAccelerationTasksRequest';
import { IGetDataAlertsResult } from '../ServerApi/requests/GetDataAlertsRequest';
import { IGetDataConnectionsResult } from '../ServerApi/requests/GetDataConnectionsRequest';
import { IGetDataRolesResult } from '../ServerApi/requests/GetDataRolesRequest';
import { IGetDatasourcesResult } from '../ServerApi/requests/GetDatasourcesRequest';
import { IGetDetailedRecentsResult } from '../ServerApi/requests/GetDetailedRecentsRequest';
import { IGetExtractTasksResult } from '../ServerApi/requests/GetExtractTasksRequest';
import { IGetFieldValuesResult } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetFlowOutputStepRunsResult } from '../ServerApi/requests/GetFlowOutputStepRunsRequest';
import { GetFlowOutputStepsResult } from '../ServerApi/requests/GetFlowOutputStepsRequest';
import { GetFlowsResult } from '../ServerApi/requests/GetFlowsRequest';
import { IGetGroupsResult } from '../ServerApi/requests/GetGroupsRequest';
import { IGetMetricsResult } from '../ServerApi/requests/GetMetricsRequest';
import { IGetProjectsResult } from '../ServerApi/requests/GetProjectsRequest';
import { IGetPublishedConnectionsResult } from '../ServerApi/requests/GetPublishedConnectionsRequest';
import { IGetRecommendedViewsResult } from '../ServerApi/requests/GetRecommendedViewsRequest';
import { IGetRemoteRefreshAgentsResult } from '../ServerApi/requests/GetRemoteRefreshAgentsRequest';
import { IRemoteRefreshSchedulesResult } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { GetRunFlowTasksResult } from '../ServerApi/requests/GetRunFlowTasksRequest';
import { IGetServerUsersResult } from '../ServerApi/requests/GetServerUsersRequest';
import { IGetShareActivityResult, ISharedVersion } from '../ServerApi/requests/GetShareActivityRequest';
import { IGetSharedWithMeResult } from '../ServerApi/requests/GetSharedWithMeRequest';
import { IGetSiteUsersResult } from '../ServerApi/requests/GetSiteUsersRequest';
import { IGetSubscriptionsResult } from '../ServerApi/requests/GetSubscriptionsRequest';
import { IGetViewsResult } from '../ServerApi/requests/GetViewsRequest';
import { IGetWorkbookAccelerationsResult } from '../ServerApi/requests/GetWorkbookAccelerationsRequest';
import { IGetWorkbooksResult } from '../ServerApi/requests/GetWorkbooksRequest';
import { IAlertList } from '../ServerApi/types/IAlert';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { IGroup } from '../ServerApi/types/IGroup';
import { IRecent } from '../ServerApi/types/IRecent';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { ISiteUser } from '../ServerApi/types/ISiteUser';
import { IMetricUsageInfo } from '../ServerApi/types/IUsageInfo';
import { IViewRecommendation } from '../ServerApi/types/IViewRecommendation';
import { IIdItem, IPathItem } from '../ServerApi/types/resourceParts';
import { mapContentFromCrass } from '../resources/Search';
import { ExploreFavoriteContentForUserResult } from '../ServerApi/requests/ExploreFavoriteContentForUserRequest';
import { IGetDatabasesResult } from '../ServerApi/requests/GetDatabasesRequest';
import { DatabaseWithCrassMapper } from '../mappers/DatabaseWithCrassMapper';
import { IDatabaseInfo } from '../models/IDatabaseInfo';
import { IUserNotification, TableauEntityType } from '@tableau/user-notifications-client-core';
import { IGetUserNotificationsResult } from '../../userNotifications/redux/serverRequests/GetUserNotificationsRequest';
import { ILensInfo } from '../models/ILensInfo';
import { LensMapper } from '../mappers/LensMapper';
import { IGetLensesResult } from '../ServerApi/requests/GetLensesRequest';
import { LocationMapper } from '../mappers/LocationMapper';
import { ITableInfo } from '../models/ITableInfo';
import { IGetTablesResult } from '../ServerApi/requests/GetTablesRequest';
import { TableWithCrassMapper } from '../mappers/TableWithCrassMapper';
import { GetContentLineageRelationshipsResult } from '../ServerApi/requests/GetContentLineageRelationshipsRequest';
import { ContentLineageRelationshipInfo } from '../models/ContentLineageRelationshipInfo';
import { ContentLineageRelationshipMapper } from '../mappers/ContentLineageRelationshipMapper';

export module ServerApiMapper {

  export function content(exploreContentResult: IExploreContentResult): IContentInfo[] {
    if(!exploreContentResult.content || exploreContentResult.content.length <= 0) return [];

    const users =  index(UserMapper.map(exploreContentResult.users));

    return ContentMapper.map(exploreContentResult.content, users);
  }

  export function favoriteFromCrass(result: ExploreFavoriteContentForUserResult): IContentInfo[] {
    if(!result.content || result.content.length <= 0) return [];

    return result.content.map((item: any) => {
      return {...mapContentFromCrass(item), favorite: true};
    });
  }

  export function projects(projectResult: IGetProjectsResult): IProjectInfo[] {
    if(!projectResult.projects || projectResult.projects.length <= 0) return [];

    const users = index(UserMapper.map(projectResult.users));

    return ProjectMapper.map(projectResult.projects, users, favorites(projectResult.favorites));
  }

  export function dataRoles(dataRoleResult: IGetDataRolesResult): IDataRoleInfo[] {
    if(!dataRoleResult.dataRoles || dataRoleResult.dataRoles.length <= 0) return [];

    const users = index(UserMapper.map(dataRoleResult.users));
    const projects = index(ProjectMapper.mapNames(dataRoleResult.projects));
    const locations = LocationMapper.map(dataRoleResult.containers);

    return DataRoleMapper.map(dataRoleResult.dataRoles, users, favorites(dataRoleResult.favorites), projects, locations);
  }

  export function lenses(lensResult: IGetLensesResult): ILensInfo[] {
    if(!lensResult.lenses || lensResult.lenses.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(lensResult.users));
    const projects = index(ProjectMapper.mapNames(lensResult.projects));

    return LensMapper.map(lensResult.lenses, users, favorites(lensResult.favorites), projects);
  }

  export function publishedConnections(result: IGetPublishedConnectionsResult): IPublishedConnectionInfo[] {
    if(!result.publishedConnections || result.publishedConnections.length <= 0) return [];

    const users = index(UserMapper.map(result.users));
    const projects = index(ProjectMapper.mapNames(result.projects));

    return PublishedConnectionMapper.map(result.publishedConnections, users, projects, favorites(result.favorites));
  }

  export function dataConnections(dataConnectionsResult: IGetDataConnectionsResult): IDataConnectionInfo[] {
    if (!dataConnectionsResult.dataConnections || dataConnectionsResult.dataConnections.length <= 0) {
      return [];
    }

    const users = index(UserMapper.map(dataConnectionsResult.users));
    const projects = index(ProjectMapper.mapNames(dataConnectionsResult.projects));
    const workbooks = index(dataConnectionsResult.workbooks);
    const dataSources = dataConnectionsResult.datasources
      ? index(DatasourceMapper.mapBasic(dataConnectionsResult.datasources, users, projects, workbooks))
      : {};
    const flows = dataConnectionsResult.flows
      ? index(FlowMapper.mapBasic(dataConnectionsResult.flows, users, projects))
      : {};

    return DataConnectionMapper.map(dataConnectionsResult.dataConnections, dataSources, flows);
  }

  export function dataSources(dataSourcesResult: IGetDatasourcesResult): IDataSourceInfo[] {
    if(!dataSourcesResult.datasources || dataSourcesResult.datasources.length <= 0) return [];

    const users = index(UserMapper.map(dataSourcesResult.users));
    const projects = index(ProjectMapper.mapNames(dataSourcesResult.projects));
    const workbooks = index(dataSourcesResult.workbooks);
    const locations = LocationMapper.map(dataSourcesResult.containers);

    return DatasourceMapper.map(dataSourcesResult.datasources, users, projects, locations, workbooks, dataSourcesResult.maxStats,
      favorites(dataSourcesResult.favorites));
  }

  export function databasesUsingCrass(databasesResult: IGetDatabasesResult): IDatabaseInfo[] {
    if(!databasesResult.databases || databasesResult.databases.length <= 0) return [];

    return DatabaseWithCrassMapper.map(databasesResult.databases, databasesResult.maxDownstreamDatasourcesViewModel, databasesResult.maxDownstreamWorkbooksViewModel);
  }

  export function tablesUsingCrass(tablesResult: IGetTablesResult): ITableInfo[] {
    if(!tablesResult.tables || tablesResult.tables.length <= 0) return [];

    return TableWithCrassMapper.map(tablesResult.tables, tablesResult.maxDownstreamDatasourcesViewModel, tablesResult.maxDownstreamWorkbooksViewModel);
  }

  export function workbooks(workbooksResult: IGetWorkbooksResult): IWorkbookInfo[] {
    if(!workbooksResult.workbooks || workbooksResult.workbooks.length <= 0) return [];

    const users = index(UserMapper.map(workbooksResult.users));
    const projects = index(ProjectMapper.mapNames(workbooksResult.projects));
    const locations = LocationMapper.map(workbooksResult.containers);

    return WorkbookMapper.map(workbooksResult.workbooks, users, projects, locations, workbooksResult.maxStats,
      favorites(workbooksResult.favorites));
  }

  export function views(viewResult: IGetViewsResult): IViewInfo[] {
    if(!viewResult.views || viewResult.views.length <= 0) return [];

    const users = index(UserMapper.map(viewResult.users));
    const projects = index(ProjectMapper.mapNames(viewResult.projects));
    const locations = LocationMapper.map(viewResult.containers);
    const workbooks = index(WorkbookMapper.mapParents(viewResult.workbooks, users, projects, locations));
    const recents = _.indexBy(viewResult.recents, 'objectId');

    return ViewMapper.map(viewResult.views, workbooks, viewResult.maxStats, favorites(viewResult.favorites), recents);
  }

  export function userNotifications(results: IGetUserNotificationsResult): IUserNotification<any>[] {
    // Filter out notifications with partial errors
    results.userNotifications = _.filter(results.userNotifications, (notification: IUserNotification<any>) => {return _.isEmpty(notification.errorInfoMap);});
    if(!results.userNotifications || results.userNotifications.length <= 0) return [];

    return _.map(results.userNotifications, (notification): IUserNotification<any> => {
      return {
        ...notification,
        eventTime: new Date(notification.eventTime),
        creationTime: new Date(notification.creationTime),
        targetInfo: {...notification.targetInfo, type: TableauEntityType[notification.targetInfo.type]}
      };
    });
  }

  export function recentItems(recentsResult: IGetDetailedRecentsResult): IRecentContentInfo[] {
    if (!recentsResult.recents || recentsResult.recents.length <= 0){
      return [];
    }

    const users = index(UserMapper.map(recentsResult.users));
    const projects = index(ProjectMapper.mapNames(recentsResult.projects));
    const locations = LocationMapper.map(recentsResult.containers);
    const workbooks = index(WorkbookMapper.mapParents(recentsResult.workbooks, users, projects, locations));
    const views = index(ViewMapper.map(recentsResult.views, workbooks, recentsResult.viewMaxStats, favorites(recentsResult.viewFavorites)));
    const connectedViews = recentsResult.connectedViews ? indexByPath(MetricMapper.mapConnectedViews(recentsResult.connectedViews)) : {};
    const metrics = recentsResult.metrics ? index(MetricMapper.map(recentsResult.metrics, users, projects, [], connectedViews, <IMetricUsageInfo>{}, favorites(recentsResult.metricFavorites)))
      : {};

    const itemsInRecentOrder: IRecentContentInfo[] = recentsResult.recents
      .filter((recent: IRecent) => recent.objectType === 'view' || recent.objectType === 'metric')
      .map((recent: IRecent) => {
        if (recent.objectType === 'view') {
          return {...views[recent.objectId], lastAccessedAt: recent.lastAccessedAt};
        } else if (recent.objectType === 'metric') {
          return {...metrics[recent.objectId], lastAccessedAt: recent.lastAccessedAt};
        }
      });

    return itemsInRecentOrder;
  }

  export function metrics(metricsResult: IGetMetricsResult): IMetricInfo[] {
    if(!metricsResult.metrics || metricsResult.metrics.length <= 0) return [];

    const users = index(UserMapper.map(metricsResult.users));
    const connectedViews = indexByPath(MetricMapper.mapConnectedViews(metricsResult.connectedViews));
    const projects = index(ProjectMapper.mapNames(metricsResult.projects));
    const locations = LocationMapper.map(metricsResult.containers);

    return MetricMapper.map(metricsResult.metrics, users, projects, locations, connectedViews, metricsResult.maxStats, favorites(metricsResult.favorites));
  }

  export function vizRecommendations(vizRecommendationsResult: IGetRecommendedViewsResult): IViewRecommendationInfo[] {
    if(!vizRecommendationsResult.recommendations || vizRecommendationsResult.recommendations.length <= 0) return [];

    const users = index(UserMapper.map(vizRecommendationsResult.users));
    const projects = index(ProjectMapper.mapNames(vizRecommendationsResult.projects));
    const workbooks = index(WorkbookMapper.mapParents(vizRecommendationsResult.workbooks, users, projects));
    const views = index(ViewMapper.map(vizRecommendationsResult.views, workbooks, vizRecommendationsResult.viewMaxStats));
    const modelId = vizRecommendationsResult.modelId;

    const vizRecommendationsParsed: IViewRecommendationInfo[] = vizRecommendationsResult.recommendations
      // filter out views from recommendation model that is no longer available in views array
      .filter((vizRec: IViewRecommendation) => views[vizRec.objectId])
      .map((vizRec: IViewRecommendation) => {
        const recommendedView = {...views[vizRec.objectId], contentType: <'recommendedView'> 'recommendedView'};
        return {
            ...recommendedView,
            modelId: modelId,
            hide: false,
            favoritesTotal: recommendedView.usageInfo.favoritesTotal,
            explanationType: vizRec.explanation.type,
            similiarUsers: vizRec.explanation.userIds && vizRec.explanation.userIds.map(userId => users[userId])
          };
      }) || [];
    return vizRecommendationsParsed;
  }

  export function shareActivity(shareActivityResult: IGetShareActivityResult): ISharedVersionInfo[] {
    if (!shareActivityResult.shareActions || shareActivityResult.shareActions.length <= 0) return [];

    const deletedSharers = index(UserMapper.map(shareActivityResult.deletedSharers));
    const sharers = index(UserWithImageMapper.map(shareActivityResult.sharers));

    let sharedVersionsByTypeThenId: _.Dictionary<_.Dictionary<ISharedVersion>> = {};
    const sharedVersionsByType = _.groupBy(shareActivityResult.viewOrCustomizedViews, 'contentType');
    Object.keys(sharedVersionsByType).forEach((type: string) => {
      sharedVersionsByTypeThenId[type] = index(sharedVersionsByType[type]);
    });

    return ShareActivityMapper.map(shareActivityResult.shareActions, sharedVersionsByTypeThenId, sharers, deletedSharers);
  }

  export function sharedWithMe(sharedWithMeResult: IGetSharedWithMeResult): ISharedWithMeContentInfo[] {
    if (!sharedWithMeResult.shareActions || sharedWithMeResult.shareActions.length <= 0) return [];

    const deletedSharers = index(UserMapper.map(sharedWithMeResult.deletedSharers));
    const owners = index(UserMapper.map(sharedWithMeResult.owners));
    const sharers = index(UserWithImageMapper.map(sharedWithMeResult.sharers));
    const customViews = index(sharedWithMeResult.underhoodCustomizedViews);
    const contentList = ContentMapper.map(sharedWithMeResult.content, owners);

    const contentByType = groupByContentType(contentList);
    let contentByTypeThenId: _.Dictionary<_.Dictionary<IContentInfo<ExplorableItemType>>> = {};
    Object.keys(contentByType).forEach((type: string) => {
      let contents = index(contentByType[type]);
      contentByTypeThenId[type] = contents;
    });

    return SharedWithMeMapper.map(sharedWithMeResult.shareActions, contentByTypeThenId, sharers, deletedSharers, sharedWithMeResult.viewsWithShareActivity, customViews);
  }

  export function flows(flowsResult: GetFlowsResult): FlowListItemInfo[] {
    if(!flowsResult.flows || flowsResult.flows.length <= 0) return [];

    const users = index(UserMapper.map(flowsResult.users));
    const projects = index(ProjectMapper.mapNames(flowsResult.projects));
    const locations = LocationMapper.map(flowsResult.containers);

    return FlowMapper.map(flowsResult.flows, users, projects, locations, flowsResult.maxStats, favorites(flowsResult.favorites));
  }


  export function flowOutputSteps(flowOutputStepsResult: GetFlowOutputStepsResult): FlowOutputStepInfo[] {
    if(!flowOutputStepsResult.outputSteps || flowOutputStepsResult.outputSteps.length <= 0) return [];

    const connections = index(flowOutputStepsResult.dataConnections);
    const datasources = index(flowOutputStepsResult.datasources);

    return FlowOutputStepMapper.map(flowOutputStepsResult.outputSteps, connections, datasources, null);
  }

  export function flowOutputStepRuns(flowOutputStepRunsResult: GetFlowOutputStepRunsResult): FlowOutputStepRunListItemInfo[] {
    if (!flowOutputStepRunsResult.flowOutputStepRuns || flowOutputStepRunsResult.flowOutputStepRuns.length <= 0) return [];

    const outputSteps = index(flowOutputStepRunsResult.flowOutputSteps);
    const runs = index(flowOutputStepRunsResult.flowRuns);

    return FlowOutputStepRunMapper.map(flowOutputStepRunsResult.flowOutputStepRuns, outputSteps, runs);
  }

  export function contentLineageRelationships(contentLineageRelationshipsResult: GetContentLineageRelationshipsResult): ContentLineageRelationshipInfo[] {
    if (contentLineageRelationshipsResult?.contentLineageRelationships?.length <= 0) return [];

    const contentLineageRelationships = contentLineageRelationshipsResult.contentLineageRelationships;

    return ContentLineageRelationshipMapper.map(contentLineageRelationships);
  }

  export function alertList(alertList: IAlertList): IAlertListInfo {
    if(!(alertList && alertList.alerts && alertList.alerts.length > 0)) return { total: 0, alerts: [] };

    const workbooks = index(alertList.workbooks);
    const datasources = index(alertList.datasources);
    const flowOutputStepRuns = index(alertList.flowOutputStepRuns);
    const flowOutputSteps = index(alertList.flowOutputSteps);
    const flows = index(alertList.flows);

    return AlertListMapper.map(alertList.totalCount, alertList.alerts, workbooks, datasources, flowOutputStepRuns, flowOutputSteps, flows);
  }

  export function accelerationTasks(accelerationTaskResult: IGetAccelerationTasksResult): IAccelerationTaskInfo[] {
    if(_.size(accelerationTaskResult.tasks) <= 0) return [];

    const schedules =   index(accelerationTaskResult.schedules);
    const sites =       index(accelerationTaskResult.sites);
    const workbooks =   index(accelerationTaskResult.workbooks);
    const projects =    index(accelerationTaskResult.projects);
    const users =    index(accelerationTaskResult.users);

    return AccelerationTaskMapper.map(accelerationTaskResult.tasks, schedules, sites, workbooks, projects, users);
  }

  export function extractTasks(extractTaskResult: IGetExtractTasksResult): IExtractTaskInfo[] {
    if(_.size(extractTaskResult.tasks) <= 0) return [];

    const schedules =   index(extractTaskResult.schedules);
    const sites =       index(extractTaskResult.sites);
    const workbooks =   index(extractTaskResult.workbooks);
    const datasources = index(extractTaskResult.datasources);

    return ExtractTaskMapper.map(extractTaskResult.tasks, schedules, sites, workbooks, datasources);
  }

  export function workbookAccelerations(workbookAccelerationResult: IGetWorkbookAccelerationsResult): IWorkbookAccelerationInfo[] {
    if(!workbookAccelerationResult.views || workbookAccelerationResult.views.length <= 0) return [];

    const viewAccelerationPerfs = _.indexBy(workbookAccelerationResult.viewAccelerationPerfs, 'viewId');
    const viewAccelerationStatus = _.indexBy(workbookAccelerationResult.viewAccelerationStatus, 'viewId');

    return WorkbookAccelerationMapper.map(workbookAccelerationResult.views, workbookAccelerationResult.maxStats, viewAccelerationPerfs, viewAccelerationStatus);
  }

  export function runFlowTasks(runFlowTasksResult: GetRunFlowTasksResult): RunFlowTaskInfo[] {
    if (runFlowTasksResult == null) return;
    if (_.size(runFlowTasksResult.tasks) <= 0) return [];

    const schedules =           index(runFlowTasksResult.schedules);
    const sites =               index(runFlowTasksResult.sites);
    const flows =               index(runFlowTasksResult.flows);
    const flowOutputSteps =     index(runFlowTasksResult.flowOutputSteps);
    const flowOutputStepRuns =  runFlowTasksResult.flowOutputStepRuns;
    const flowRuns =            runFlowTasksResult.flowRuns;
    const dataConnections =     index(runFlowTasksResult.dataConnections);

    return RunFlowTaskMapper.map(runFlowTasksResult.tasks, schedules, sites, flows, dataConnections, flowOutputSteps, flowRuns, flowOutputStepRuns);
  }

  export function remoteRefreshSchedules(remoteRefreshSchedulesResult: IRemoteRefreshSchedulesResult): IRemoteRefreshScheduleInfo[] {
    if(_.size(remoteRefreshSchedulesResult.schedules) <= 0) return [];

    return RemoteRefreshScheduleMapper.mapToResource(remoteRefreshSchedulesResult);
  }

  export function remoteRefreshAgents(remoteRefreshAgentsResult: IGetRemoteRefreshAgentsResult): IRemoteRefreshAgentInfo[] {
    if(_.size(remoteRefreshAgentsResult.agents) <= 0) return [];

    return RemoteRefreshAgentMapper.mapToResource(remoteRefreshAgentsResult.agents);
  }

  export function customViews(customViewResult: IGetCustomizedViewsResult): ICustomViewInfo[] {
    if(_.size(customViewResult.customViews) <= 0) return [];

    return CustomViewMapper.map(
      customViewResult.customViews,
      index(customViewResult.sites),
      customViewResult.maxStats,
      index(customViewResult.users),
    );
  }

  export function subscriptions(subscriptionResult: IGetSubscriptionsResult): ISubscriptionInfo[] {
    if(_.size(subscriptionResult.subscriptions) <= 0) return [];

    return SubscriptionMapper.map(
      subscriptionResult.subscriptions,
      index(subscriptionResult.schedules),
      index(subscriptionResult.sites),
      index(subscriptionResult.users)
    );
  }

  export function dataAlerts(dataAlertsResult: IGetDataAlertsResult): IDataAlertInfo[] {
    if(_.size(dataAlertsResult.dataAlerts) <= 0) return [];

    return DataAlertMapper.map(
      dataAlertsResult.dataAlerts,
      index(dataAlertsResult.users),
      index(dataAlertsResult.groups)
    );
  }

  export function groups(groupsResult: IGetGroupsResult): IGroupInfo[] {
    return groupsResult.groups.map((group: IGroup) => {
      const groupInfo: IGroupInfo = {
        ...group,
        contentType: 'group'
      };
      return groupInfo;
    });
  }

  export function siteUsers(siteUsersResult: IGetSiteUsersResult): ISiteUserInfo[] {
    return siteUsersResult.users.map((user: ISiteUser) => {
      const userInfo: ISiteUserInfo = {
        ...user,
        contentType: 'siteuser'
      };
      return userInfo;
    });
  }

  export function serverUsers(serverUsersResult: IGetServerUsersResult): IServerUserInfo[] {
    return serverUsersResult.users.map((user: IServerUser) => {
      const userInfo: IServerUserInfo = {
        ...user,
        contentType: 'serveruser'
      };
      return userInfo;
    });
  }

  export function fieldValues(fieldValueResult: IGetFieldValuesResult): IFieldValue[] {
    return fieldValueResult.fieldValues;
  }

  function favorites(ids: string[]) {
    return _.indexBy(ids, _.identity);
  }

  function index<T extends IIdItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
    return _.indexBy(items, 'id');
  }

  function indexByPath<T extends IPathItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
    return _.indexBy(items, 'path');
  }

  function groupByContentType<T extends IContentInfo>(items: ReadonlyArray<T>): _.Dictionary<T[]> {
    return _.groupBy(items, 'contentType');
  }
}
